import {
  DEFAULT_ROOT_ROUTE_NAME,
  DEFAULT_ROUTE_NAME,
} from '@/router/constants';
import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

// 临时首页
const HomeIndex: AppRouteRecordRaw = {
  path: '/home',
  name: DEFAULT_ROOT_ROUTE_NAME,
  component: DEFAULT_LAYOUT,
  redirect: '/home/index',
  // component: () => import('@/views/homePage/index.vue'),
  meta: {
    title: '首页',
    requiresAuth: true,
    icon: 'icon-home',
    order: 0,
    activeMenu: DEFAULT_ROUTE_NAME,
  },
  children: [
    {
      path: 'index',
      name: DEFAULT_ROUTE_NAME,
      component: () => import('@/views/home/index.vue'),
      meta: {
        title: '首页',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['*'],
        activeMenu: DEFAULT_ROUTE_NAME,
      },
    },
  ],
};

export default HomeIndex;
